"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=7404%3A1035))
 * @trackcomponent
 * @lastsynced 2025-03-05T22:12:21.736Z
 */
export const Quality = createSVGIcon(
  <>
    <g clipPath="url(#clip0_7404_1035)">
      <path
        d="M12.6092 22.8867C12.2171 23.0378 11.7828 23.0378 11.3907 22.8867C8.33152 21.7127 5.70054 19.639 3.84535 16.9392C1.99014 14.2394 0.998018 11.0407 1 7.76556V2.69139C1 2.24281 1.1783 1.81259 1.49567 1.4954C1.81304 1.1782 2.24348 1 2.6923 1H21.3076C21.7564 1 22.1869 1.1782 22.5043 1.4954C22.8217 1.81259 23 2.24281 23 2.69139V7.76556C23.0019 11.0407 22.0098 14.2394 20.1547 16.9392C18.2994 19.639 15.6684 21.7127 12.6092 22.8867Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3504 6.88379L10.525 14.5582L7.1123 12.0001"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7404_1035">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </>,
  "Quality",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
